import { render, staticRenderFns } from "./sendBoxBot.vue?vue&type=template&id=056c5b05&scoped=true"
import script from "./sendBoxBot.vue?vue&type=script&lang=js"
export * from "./sendBoxBot.vue?vue&type=script&lang=js"
import style0 from "./sendBoxBot.vue?vue&type=style&index=0&id=056c5b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056c5b05",
  null
  
)

export default component.exports